module.exports = __webpack_public_path__ + "canada-d1b7320fae1f3235752d4702cf5454e8.png";